import apiClientCreator from "../../../../../helpers/api/request";

export const assignmentUnTag = (client, fromGroup) => {
  return apiClientCreator(`client/assign/renew/${client.id}`)
    .post("", {
      from_group: client.assignment_group.assigned_to.id
    })
    .then(async res => {
      return res;
    });
};
export const tagBN = (selectedTag, clientId) => {
  const apiClient = apiClientCreator(`client/bad-number/${clientId}`, "token");
  return apiClient.post("", { tag_id: selectedTag.id }).then(res => {
    return res;
  });
};

export const untagBN = (tagIdNum, clientId) => {
  return apiClientCreator(`client/bad-number/${clientId}`)
    .delete("", { data: { tag_id_num: tagIdNum } })
    .then(res => {
      return res;
    });
};

export const tagNI = (selectedTag, clientId) => {
  const apiClient = apiClientCreator(
    `client/not-interested/${clientId}`,
    "token"
  );
  return apiClient.post("", { tag_id: selectedTag.id }).then(res => {
    return res;
  });
};
export const untagNI = (tagIdNum, clientId) => {
  return apiClientCreator(`client/not-interested/${clientId}`)
    .delete("", { data: { tag_id_num: tagIdNum } })
    .then(res => {
      return res;
    });
};

export const tagNA = (selectedTag, clientId) => {
  const apiClient = apiClientCreator(`client/na/${clientId}`, "token");
  return apiClient.post("", { tag_id: selectedTag.id }).then(res => {
    return res;
  });
};

export const tagTier4 = clientId => {
  return apiClientCreator(`client/tier/${clientId}`)
    .put("")
    .then(res => {
      return res;
    });
};

export const addSkype = (clientId, newSkype) => {
  return apiClientCreator(`client/skype/${clientId}`)
    .post("", { contact_value: newSkype })
    .then(res => {
      return res;
    });
};

export const updateSkype = (clientId, newSkype, skypeNumId) => {
  return apiClientCreator(`client/skype/${clientId}`)
    .put("", { contact_value: newSkype, skype_id_num: skypeNumId })
    .then(res => {
      return res;
    });
};
